import { FunctionalComponent } from 'preact';
import {
  useCheckoutStore,
  useSelector,
} from '@primer-io/shared-library/contexts';
import { VaultListItem } from '../types';

import PaymentMethodTokenItem from './PaymentMethodTokenItem';

type Props = {
  vaultedItem: VaultListItem;
};

const VaultedPaymentMethod: FunctionalComponent<Props> = ({ vaultedItem }) => {
  const store = useCheckoutStore();
  const selectedVault = useSelector((s) => s.vault.selected);
  const selected = vaultedItem.id === selectedVault;

  const handleSelect = () => {
    store.selectVault(vaultedItem.id);
  };

  return (
    <PaymentMethodTokenItem
      vaultedItem={vaultedItem}
      selected={selected}
      onSelect={handleSelect}
    />
  );
};

export default VaultedPaymentMethod;
